import classNames from "classnames";
import { BasicProps } from "./ComponentsInterface";

export const LFlex = ({ ...props }: LFlexProps): JSX.Element => {
    const classes = classNames(
        "is-flex",
        props.row ? "is-flex-direction-row" : "is-flex-direction-column",
        props.justifyCenter ? "is-justify-content-center" : "",
        props.alignCenter ? "is-align-items-center" : "",
        props.className
    );

    return (
        <div className={classes} style={{ width: props.fullWidth ? "100%" : undefined }}>
            {props.children}
        </div>
    );
};

interface LFlexProps extends BasicProps {
    row?: boolean;
    justifyCenter?: boolean;
    alignCenter?: boolean;
    fullWidth?: boolean;
}
